import { render, staticRenderFns } from "./authorized.vue?vue&type=template&id=3baaaf7e&scoped=true&"
import script from "./authorized.vue?vue&type=script&lang=js&"
export * from "./authorized.vue?vue&type=script&lang=js&"
import style0 from "./authorized.vue?vue&type=style&index=0&id=3baaaf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baaaf7e",
  null
  
)

export default component.exports